<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.loadingOrderEdit" type="confirm" width="40%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="order" :rules="rules" :wrapper-col="{span:16}">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.loadingOrderNo')" :label-col="{span:4}" :wrapper-col="{span:20}">
            <vxe-input v-model="order.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.dispatcher')">
            <vxe-input v-model="order.dispatcher" :editable="false" style="width: 100%" @clear="onUserChange([{}],'dispatcher')" @click="onUserSelect('dispatcherModal','配送员')"/>
            <user-modal ref="dispatcherModal" @change="(v)=>onUserChange(v,'dispatcher')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.deliver')" prop="deliver">
            <vxe-input v-model="order.deliverer" :editable="false" style="width: 100%" @clear="onUserChange([{}],'deliverer')" @click="onUserSelect('delivererModal','配送员')"/>
            <user-modal ref="delivererModal" @change="(v)=>onUserChange(v,'deliverer')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.driver')" prop="driver">
            <vxe-input v-model="order.driver" :editable="false" style="width: 100%" @clear="onUserChange([{}],'driver')" @click="onUserSelect('driverModal','司机')"/>
            <user-modal ref="driverModal" @change="(v)=>onUserChange(v,'driver')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.phone')" prop="driverPhone">
            <vxe-input v-model="order.driverPhone" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.vehicleNo')" prop="vehicleNo">
            <vxe-input v-model="order.vehicle.no" :editable="false" style="width: 100%" @clear="onVehicleChange([])" @click="onVehicleSelect"/>
            <vehicle-modal ref="vehicleModal" @change="onVehicleChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.vehicleInPlaceStatus')" prop="vehicleInPlaceStatus">
            <vxe-input v-model="order.vehicleInPlaceStatus" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.departureTime')" prop="departureTime">
            <vxe-date-picker v-model="order.departureTime" style="width: 100%" type="datetime"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.dock')" prop="dock">
            <vxe-input v-model="order.dock.no" :editable="false" style="width: 100%" @clear="onDockChange([])" @click="onDockSelect"/>
            <location-modal ref="dockModal" @change="onDockChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.notes')" :label-col="{span:4}" :wrapper-col="{span:20}">
            <vxe-textarea v-model="order.notes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import api from '@/api'
import UserModal from '@/views/modal/UserModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import VehicleModal from '@/views/modal/VehicleModal.vue'
import { LoadingOrder } from '@/api/dto/order/LoadingOrder'
import { Location } from '@/api/dto/common/Location'
import { Vehicle } from '@/api/dto/common/Vehicle'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  components: { VehicleModal, LocationModal, UserModal },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new LoadingOrder(),
      ids: [],
      orderNos: [],
      args: {
        dispatcher: null,
        deliverer: null,
        driver: null,
        driverPhone: null,
        vehicleInPlaceStatus: null,
        departureTime: null,
        notes: null,
        vehicle: new Vehicle(),
        dock: new Location()
      },
      rules: {},
      record: null
    }
  },
  methods: {
    onUserSelect(modal, name) {
      this.$refs[modal].open({ 'role.name': name })
    },
    onUserChange(values, field) {
      this.order[field] = values[0].name
    },
    onVehicleSelect() {
      this.$refs.vehicleModal.open()
    },
    onVehicleChange(values) {
      this.order.vehicle = new Vehicle(values[0])
    },
    onDockSelect() {
      this.$refs.dockModal.open({ locationType: 3 })
    },
    onDockChange(values) {
      this.order.dock = new Location(values[0])
    },
    open(records) {
      this.visible = true
      console.log(records)
      if (records.length > 0) {
        records.forEach(record => {
          this.ids.push(record.order.id)
          this.orderNos.push(record.order.no)
        })
      }
      if (records.length === 1) {
        this.order = new LoadingOrder(BaseObject.merge(records[0], 'order'))
        this.ids = [this.order.id]
        this.orderNos = [this.order.no]
      }
    },
    save() {
      this.loading = true
      const args = {
        ...this.order.toJSONObject(),
        ids: [this.order.id]
      }
      post(api.deliveryCheckIn, {}, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('postSave')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>